<template>
  <div class="bookStoreStatic-container app-container">
    <div class="bookStoreStatic-header bg-white">
      <div class="bookStoreStatic-header-left">
        <h3>购买流量统计</h3>
      </div>
      <div class="bookStoreStatic-header-right">
        <!-- <list-search @listSearchEvn="listSearchEvn" /> -->
        <div class="bookStoreStatic-header-right-date">
          <p>统计日期：</p>
          <el-date-picker
            v-model="dateVal"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="dateHandle"
          >
          </el-date-picker>
        </div>
        <div class="bookStoreStatic-date-select">
          <span
            v-for="item in dateTypeOpts"
            :key="item.type"
            class="bookStoreStatic-date-select-item"
            :class="{
              'bookStoreStatic-date-select-active':
                params.dateType === item.type
            }"
            @click="changeType(item.type)"
            >{{ item.label }}</span
          >
        </div>
      </div>
    </div>
    <div class="bookStoreStatic-main" v-bar>
      <div>
        <div v-for="(item, key) in chartData" :key="key">
          <el-card
            class="bookStoreStatic-chart"
            :body-style="{ padding: '20px 10px' }"
          >
            <div class="bookStoreStatic-item">
              <div class="bookStoreStatic-item-header">
                <h3>{{ item.title }}</h3>
              </div>
              <LineChart :chartData="item.data" />
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from './components/lineChart'
export default {
  components: { LineChart },
  data() {
    return {
      params: {
        dateType: 1
      },
      dateVal: [],
      dateTypeOpts: [
        {
          type: 1,
          label: '今日'
        },
        {
          type: 2,
          label: '最近七天'
        },
        {
          type: 3,
          label: '最近30天'
        }
      ],
      chartData: {
        userData: {
          title: '京东购买人数统计',
          data: []
        },
        amountData: {
          title: '京东购买金额统计',
          data: []
        },
        activeData: {
          title: '设备活跃量',
          data: []
        }
      }
    }
  },

  methods: {
    init() {
      this.getJDdeviceRecord()
      this.getStatisticsAmountByDate()
      this.getStatisticsUserByDate()
    },
    async getJDdeviceRecord() {
      let res = await this.$http.getJDdeviceRecord(this.params)
      this.chartData.activeData.data = this.filterData(res.result)
    },
    async getStatisticsAmountByDate() {
      let res = await this.$http.getStatisticsAmountByDate(this.params)
      this.chartData.amountData.data = this.filterData(res)
    },
    async getStatisticsUserByDate() {
      let res = await this.$http.getStatisticsUserByDate(this.params)
      this.chartData.userData.data = this.filterData(res)
    },
    filterData(arr) {
      return arr.map((item) => {
        if (this.params.dateType === 1) {
          return {
            count: item.count,
            date: `${item.year}/${item.month}/${item.day}`
          }
        } else if (this.params.dateType === 2) {
          return {
            count: item.count,
            date: `${item.year}-${item.week}周`
          }
        } else {
          return {
            count: item.count,
            date: `${item.year}/${item.month}`
          }
        }
      })
    },
    changeType(type) {
      this.params.dateType = type
      this.init()
    },
    dateHandle(date) {
      if (date) {
        ;[this.params.start, this.params.end] = date
      } else {
        delete this.params.start
        delete this.params.end
      }
      this.init()
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss">
.bookStoreStatic-container {
  .bookStoreStatic-header {
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .bookStoreStatic-header-top {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 20px 0 30px;
      border-bottom: 1px solid $globalBorderColor;
      margin-bottom: 20px;
    }
    .bookStoreStatic-header-right {
      display: flex;
      justify-content: flex-end;
      /* margin-top: 20px; */
      .bookStoreStatic-header-right-date {
        display: flex;
        align-items: center;
        .bookStoreStatic-date-select {
          .bookStoreStatic-date-select-item {
            display: inline-block;
            padding: 6px 12px;
            margin-left: 20px;
            font-size: 14px;
            border-radius: 4px;
            border: none;
            outline: none;
            cursor: pointer;
            -webkit-transition: all 0.3s;
            transition: all 0.3s;
            background: #ccc;
            color: #fff;
          }
          .bookStoreStatic-date-select-active {
            background: #bf735b;
            color: #fff;
          }
        }
      }
    }
  }
  .bookStoreStatic-date-select {
    .bookStoreStatic-date-select-item {
      display: inline-block;
      padding: 6px 12px;
      margin-left: 20px;
      font-size: 14px;
      border-radius: 4px;
      border: none;
      outline: none;
      cursor: pointer;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      background: #ccc;
      color: #fff;
    }
    .bookStoreStatic-date-select-active {
      background: #bf735b;
      color: #fff;
    }
  }
  .bookStoreStatic-main {
    flex: 1;
    padding: 20px;
    overflow: hidden;
    .bookStoreStatic-chart {
      margin-bottom: 20px;
      .bookStoreStatic-item {
        .bookStoreStatic-item-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 20px 20px;
        }
      }
    }
  }
}
</style>
